import {
  cycleCountRuleStatusSchema,
  cycleCountRuleTypeSchema,
} from "@redotech/redo-inventory-common/cycle-counts";
import { cycleCountRuleIdFormat } from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const cycleCountRuleListItem = z.object({
  id: cycleCountRuleIdFormat.schema,
  name: z.string(),
  description: z.string().nullable(),
  type: cycleCountRuleTypeSchema,
  status: cycleCountRuleStatusSchema,
  data: z.unknown(),
  dueDaysAfterCreation: z.int(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const cycleCountRuleSortBySchema = z.enum(["name", "status", "type"]);

export const listCycleCountRules = unaryRpc({
  name: "listCycleCountRules" as const,
  input: z.object({
    search: z.string().nullable(),
    statuses: z.array(cycleCountRuleStatusSchema).nullable(),
    sortBy: cycleCountRuleSortBySchema.nullable(),
    sortDirection: z.enum(["asc", "desc"]).nullable(),
  }),
  output: z.object({ rules: z.array(cycleCountRuleListItem) }),
});
